import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AddTenantEmailSenderMutationVariables = Types.Exact<{
  input: Types.AddTenantEmailSenderInput;
}>;


export type AddTenantEmailSenderMutation = { __typename?: 'Mutation', addTenantEmailSender: { __typename?: 'TenantEmailSenderPayload', sender?: { __typename?: 'TenantEmailSenderData', senderId: string, email: string, displayName: string, verificationMethod?: Types.EmailSenderVerificationMethod | null, channel: Types.EmailSenderChannel, verificationStatus: Types.EmailSenderVerificationStatus, sendGridSenderId?: string | null, isDefault: boolean, adminOnly: boolean } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RequestTenantEmailSenderVerificationMutationVariables = Types.Exact<{
  input: Types.RequestTenantEmailSenderVerificationInput;
}>;


export type RequestTenantEmailSenderVerificationMutation = { __typename?: 'Mutation', requestTenantEmailSenderVerification: { __typename?: 'TenantEmailSenderPayload', sender?: { __typename?: 'TenantEmailSenderData', senderId: string, email: string, displayName: string, verificationMethod?: Types.EmailSenderVerificationMethod | null, channel: Types.EmailSenderChannel, verificationStatus: Types.EmailSenderVerificationStatus, sendGridSenderId?: string | null, isDefault: boolean, adminOnly: boolean } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RefreshTenantEmailSenderStatusMutationVariables = Types.Exact<{
  input: Types.RefreshTenantEmailSenderStatusInput;
}>;


export type RefreshTenantEmailSenderStatusMutation = { __typename?: 'Mutation', refreshTenantEmailSenderStatus: { __typename?: 'TenantEmailSenderPayload', sender?: { __typename?: 'TenantEmailSenderData', senderId: string, email: string, displayName: string, verificationMethod?: Types.EmailSenderVerificationMethod | null, channel: Types.EmailSenderChannel, verificationStatus: Types.EmailSenderVerificationStatus, sendGridSenderId?: string | null, isDefault: boolean, adminOnly: boolean } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetTenantDefaultEmailSenderMutationVariables = Types.Exact<{
  input: Types.SetTenantDefaultEmailSenderInput;
}>;


export type SetTenantDefaultEmailSenderMutation = { __typename?: 'Mutation', setTenantDefaultEmailSender: { __typename?: 'TenantEmailSenderPayload', sender?: { __typename?: 'TenantEmailSenderData', senderId: string, email: string, displayName: string, verificationMethod?: Types.EmailSenderVerificationMethod | null, channel: Types.EmailSenderChannel, verificationStatus: Types.EmailSenderVerificationStatus, sendGridSenderId?: string | null, isDefault: boolean, adminOnly: boolean } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveTenantEmailSenderMutationVariables = Types.Exact<{
  input: Types.RemoveTenantEmailSenderInput;
}>;


export type RemoveTenantEmailSenderMutation = { __typename?: 'Mutation', removeTenantEmailSender: { __typename?: 'TenantEmailSenderPayload', sender?: { __typename?: 'TenantEmailSenderData', senderId: string, email: string, displayName: string, verificationMethod?: Types.EmailSenderVerificationMethod | null, channel: Types.EmailSenderChannel, verificationStatus: Types.EmailSenderVerificationStatus, sendGridSenderId?: string | null, isDefault: boolean, adminOnly: boolean } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CompleteTenantEmailSenderVerificationMutationVariables = Types.Exact<{
  input: Types.CompleteTenantEmailSenderVerificationInput;
}>;


export type CompleteTenantEmailSenderVerificationMutation = { __typename?: 'Mutation', completeTenantEmailSenderVerification: { __typename?: 'TenantEmailSenderPayload', sender?: { __typename?: 'TenantEmailSenderData', senderId: string, email: string, displayName: string, verificationMethod?: Types.EmailSenderVerificationMethod | null, channel: Types.EmailSenderChannel, verificationStatus: Types.EmailSenderVerificationStatus, sendGridSenderId?: string | null, isDefault: boolean, adminOnly: boolean } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetEmailSenderAdminOnlyMutationVariables = Types.Exact<{
  input: Types.SetEmailSenderAdminOnlyInput;
}>;


export type SetEmailSenderAdminOnlyMutation = { __typename?: 'Mutation', setEmailSenderAdminOnly: { __typename?: 'TenantEmailSenderPayload', sender?: { __typename?: 'TenantEmailSenderData', senderId: string, email: string, displayName: string, verificationMethod?: Types.EmailSenderVerificationMethod | null, channel: Types.EmailSenderChannel, verificationStatus: Types.EmailSenderVerificationStatus, sendGridSenderId?: string | null, isDefault: boolean, adminOnly: boolean } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const AddTenantEmailSenderDocument = new TypedDocumentString(`
    mutation AddTenantEmailSender($input: AddTenantEmailSenderInput!) {
  addTenantEmailSender(input: $input) {
    sender {
      ...TenantEmailSender
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantEmailSender on TenantEmailSenderData {
  senderId
  email
  displayName
  verificationMethod
  channel
  verificationStatus
  sendGridSenderId
  isDefault
  adminOnly
}`);
export const RequestTenantEmailSenderVerificationDocument = new TypedDocumentString(`
    mutation RequestTenantEmailSenderVerification($input: RequestTenantEmailSenderVerificationInput!) {
  requestTenantEmailSenderVerification(input: $input) {
    sender {
      ...TenantEmailSender
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantEmailSender on TenantEmailSenderData {
  senderId
  email
  displayName
  verificationMethod
  channel
  verificationStatus
  sendGridSenderId
  isDefault
  adminOnly
}`);
export const RefreshTenantEmailSenderStatusDocument = new TypedDocumentString(`
    mutation RefreshTenantEmailSenderStatus($input: RefreshTenantEmailSenderStatusInput!) {
  refreshTenantEmailSenderStatus(input: $input) {
    sender {
      ...TenantEmailSender
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantEmailSender on TenantEmailSenderData {
  senderId
  email
  displayName
  verificationMethod
  channel
  verificationStatus
  sendGridSenderId
  isDefault
  adminOnly
}`);
export const SetTenantDefaultEmailSenderDocument = new TypedDocumentString(`
    mutation SetTenantDefaultEmailSender($input: SetTenantDefaultEmailSenderInput!) {
  setTenantDefaultEmailSender(input: $input) {
    sender {
      ...TenantEmailSender
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantEmailSender on TenantEmailSenderData {
  senderId
  email
  displayName
  verificationMethod
  channel
  verificationStatus
  sendGridSenderId
  isDefault
  adminOnly
}`);
export const RemoveTenantEmailSenderDocument = new TypedDocumentString(`
    mutation RemoveTenantEmailSender($input: RemoveTenantEmailSenderInput!) {
  removeTenantEmailSender(input: $input) {
    sender {
      ...TenantEmailSender
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantEmailSender on TenantEmailSenderData {
  senderId
  email
  displayName
  verificationMethod
  channel
  verificationStatus
  sendGridSenderId
  isDefault
  adminOnly
}`);
export const CompleteTenantEmailSenderVerificationDocument = new TypedDocumentString(`
    mutation CompleteTenantEmailSenderVerification($input: CompleteTenantEmailSenderVerificationInput!) {
  completeTenantEmailSenderVerification(input: $input) {
    sender {
      ...TenantEmailSender
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantEmailSender on TenantEmailSenderData {
  senderId
  email
  displayName
  verificationMethod
  channel
  verificationStatus
  sendGridSenderId
  isDefault
  adminOnly
}`);
export const SetEmailSenderAdminOnlyDocument = new TypedDocumentString(`
    mutation SetEmailSenderAdminOnly($input: SetEmailSenderAdminOnlyInput!) {
  setEmailSenderAdminOnly(input: $input) {
    sender {
      ...TenantEmailSender
    }
    errors {
      code
      message
    }
  }
}
    fragment TenantEmailSender on TenantEmailSenderData {
  senderId
  email
  displayName
  verificationMethod
  channel
  verificationStatus
  sendGridSenderId
  isDefault
  adminOnly
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AddTenantEmailSender: build.mutation<AddTenantEmailSenderMutation, AddTenantEmailSenderMutationVariables>({
      query: (variables) => ({ document: AddTenantEmailSenderDocument, variables })
    }),
    RequestTenantEmailSenderVerification: build.mutation<RequestTenantEmailSenderVerificationMutation, RequestTenantEmailSenderVerificationMutationVariables>({
      query: (variables) => ({ document: RequestTenantEmailSenderVerificationDocument, variables })
    }),
    RefreshTenantEmailSenderStatus: build.mutation<RefreshTenantEmailSenderStatusMutation, RefreshTenantEmailSenderStatusMutationVariables>({
      query: (variables) => ({ document: RefreshTenantEmailSenderStatusDocument, variables })
    }),
    SetTenantDefaultEmailSender: build.mutation<SetTenantDefaultEmailSenderMutation, SetTenantDefaultEmailSenderMutationVariables>({
      query: (variables) => ({ document: SetTenantDefaultEmailSenderDocument, variables })
    }),
    RemoveTenantEmailSender: build.mutation<RemoveTenantEmailSenderMutation, RemoveTenantEmailSenderMutationVariables>({
      query: (variables) => ({ document: RemoveTenantEmailSenderDocument, variables })
    }),
    CompleteTenantEmailSenderVerification: build.mutation<CompleteTenantEmailSenderVerificationMutation, CompleteTenantEmailSenderVerificationMutationVariables>({
      query: (variables) => ({ document: CompleteTenantEmailSenderVerificationDocument, variables })
    }),
    SetEmailSenderAdminOnly: build.mutation<SetEmailSenderAdminOnlyMutation, SetEmailSenderAdminOnlyMutationVariables>({
      query: (variables) => ({ document: SetEmailSenderAdminOnlyDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAddTenantEmailSenderMutation, useRequestTenantEmailSenderVerificationMutation, useRefreshTenantEmailSenderStatusMutation, useSetTenantDefaultEmailSenderMutation, useRemoveTenantEmailSenderMutation, useCompleteTenantEmailSenderVerificationMutation, useSetEmailSenderAdminOnlyMutation } = injectedRtkApi;
